<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

<!-- ============================== Header =============================================== --> 

  
$(document).on('click','.header-clode-btn', function(){
  $('body').removeClass('overflow-hidden-desktop');
  $(".section-header").removeClass('menu-open');
  $(".menu-drawer-container").removeClass('menu-opening');
  // $('html').removeClass('drawer_active');
});


<!-- ============================== Footer =============================================== --> 


  function initDropdownColumnsFooter() {
    var footerColumnTitle = document.querySelectorAll('.footer-1 [data-toggle-column-footer]');
    if (footerColumnTitle.length > 0) {
      for (i = 0; i < footerColumnTitle.length; i++) {
        (function (i) {
          footerColumnTitle[i].addEventListener('click', function (event) {
            var $this = event.target;
            if ($this.classList.contains('is-clicked')) {
              $this.classList.remove('is-clicked');
            } else {
              $this.classList.add('is-clicked');
            }
          });
        })(i);
      }
    }
  }
  initDropdownColumnsFooter();



<!-- ============================== Product page Media slider =============================================== --> 


$('.main-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.thumbnail-slider'
});
$('.thumbnail-slider').slick({
    slidesToShow: 5,
    slidesToScroll: 2,
    vertical:true,
    asNavFor: '.main-slider',
    dots: false,
    arrows: false,
    focusOnSelect: true,
    verticalSwiping:true,
    responsive: [
    {
        breakpoint: 991,
        settings: {
           vertical: false,
           slidesToShow: 5,
        }
    },
    {
      breakpoint: 767,
      settings: {
        vertical: false,
        verticalSwiping:false,
        slidesToShow: 4,
      }
    }
    ]
});


<!-- ============================== Product page for video Block =============================================== --> 


const popupWrappers = document.querySelectorAll(".popup-wrapper:not(.no-close)");
function close_popup(wrapper) {
    (wrapper.style.display = "none"),
        wrapper.querySelectorAll("video").forEach((video) => {
            video.paused || video.pause();
        });
}
popupWrappers.forEach((wrapper) => {
    wrapper.addEventListener("click", (e2) => {
        e2.target === wrapper && (e2.preventDefault(), close_popup(wrapper));
    });
});
const closeButtons = document.querySelectorAll(".close-popup");
closeButtons.forEach((button) => {
    button.addEventListener("click", (e2) => {
        e2.preventDefault();
        const wrapper = button.closest(".popup-wrapper");
        wrapper && close_popup(wrapper);
    });
});

  
function handleVideoClick() {
    const prodVidContainers = document.querySelectorAll(".video-preview-wrap"),
        videoPopupMedia = document.getElementById("video-popup-media"),
        videoPopup = document.getElementById("video-popup");
    prodVidContainers.forEach((container) => {
        container.addEventListener("click", () => {
            const videoSrc = container.dataset.src;
            videoSrc &&
                ((videoPopupMedia.querySelector("source").src = videoSrc),
                (videoPopup.style.display = "block"),
                videoPopup.addEventListener("transitionend", () => {
                    videoPopup.style.opacity = 1;
                }),
                videoPopupMedia.load(),
                videoPopupMedia.play(),
                (videoPopupMedia.muted = !1));
        });
    });
}
handleVideoClick();
function section_social_videos(videoSection) {
    const videoPlayers = videoSection.querySelectorAll("video");
    let currentVideoIndex = videoPlayers.length;
    let videos_loaded = false;

    function playNextVideo() {
        // Increment the index and reset if it exceeds the array length
        currentVideoIndex++;
        if (currentVideoIndex >= videoPlayers.length) {
            currentVideoIndex = 0;
        }

        // Pause all videos and remove "active" class from all video list items
        for (let i3 = 0; i3 < videoPlayers.length; i3++) {
            videoPlayers[i3].pause();
            videoPlayers[i3].closest("li").classList.remove("active");
        }

        // Get the current video and update its source if necessary
        const current_video = videoPlayers[currentVideoIndex];
        for (let source in current_video.children) {
            const videoSource = current_video.children[source];
            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                videoSource.src = videoSource.dataset.src;
            }
        }

        // Add the "active" class to the current video list item and play the video
        current_video.closest("li").classList.add("active");
        current_video.play();

        // Automatically switch to the next video after 5 seconds
        setTimeout(playNextVideo, 5000);
    }

    function loadVideos() {
        if (!videos_loaded) {
            videos_loaded = true;
            for (let i3 = 0; i3 < videoPlayers.length; i3++) {
                const current_video = videoPlayers[i3];
                for (let source in current_video.children) {
                    const videoSource = current_video.children[source];
                    if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                        videoSource.src = videoSource.dataset.src;
                    }
                }
                current_video.load();
            }
        }
    }

    const scrollHandler = function () {
        if (videoSection.getBoundingClientRect().top >= 0 && videoSection.getBoundingClientRect().bottom <= window.innerHeight) {
            loadVideos();
            playNextVideo();
            window.removeEventListener("scroll", scrollHandler);
        }
    };

    window.addEventListener("scroll", scrollHandler);
}

const videoSections = document.querySelectorAll(".autoplay-videos");
for (let i = 0; i < videoSections.length; i++) {
    section_social_videos(videoSections[i]);
}


<!-- ============================== On click Scroll Js =============================================== --> 
  
$(document).on('click','.product-scroll-btn', function(){
    $('html, body').animate({
        scrollTop: $(".product-new-main-section").offset().top
     }, 100);

});


  
$(document).on('click','.header-scroll-btn', function(){
    $('html, body').animate({
        scrollTop: $(".patented_inner-cntr").offset().top
     }, 100);

});


$(document).on('click','.scroll-reviews', function(){

    $('html, body').animate({
        scrollTop: $(".product-reviews-widget-section").offset().top
     }, 100);

});
  
$(document).on('click','.product-scroll-bottom', function(){

    $('html, body').animate({
        scrollTop: $(".product-new-main-section").offset().top
     }, 100);

});

 $(document).on('click','.custom-star-rating-block', function(){

    $('html, body').animate({
        scrollTop: $(".product-reviews-widget-section").offset().top
     }, 100);

}); 
  




<!-- ============================== Product page Images Slider =============================================== --> 

$('.owl-carousel-5').owlCarousel({
    loop:true,
    margin:30,
    nav:true,
    navText : ["<img src='https://cdn.shopify.com/s/files/1/0810/8372/8157/files/White_Left.svg?v=1722676743'>","<img src='https://cdn.shopify.com/s/files/1/0810/8372/8157/files/White_Right.svg?v=1722676743'>"],
    autoplay:false,
    dots: false,
    autoplayHoverPause:true,
    autoHeight: true,
    autoplayTimeout:5000,
    responsive:{
        0:{
            items:2
          
        },
        600:{
            items:2
        },
        1000:{
            items:4
        }
    }
});



  
<!-- ============================== Product page video Section slider =============================================== --> 
  
$(document).on('click','.product-videos-item', function(){
    let currentVideo = $(this).children(".contests-video").get(0);

    // Pause all other videos and show their thumbnails and play buttons
    $(".contests-video").each(function () {
      if (this !== currentVideo) {
        this.pause();
        $(this).siblings(".video-list-img").fadeIn();
        $(this).siblings('.play-icon').show();
      }
    });

    // Toggle play/pause for the clicked video
    if (currentVideo.paused) {  
      currentVideo.play();
      $(this).children(".video-list-img").fadeOut();
      $(this).children('.play-icon').hide();
    } else {   
      currentVideo.pause();
      $(this).children(".video-list-img").fadeIn();
      $(this).children('.play-icon').show();
    }
  });


$('.owl-carousel-6').owlCarousel({
    loop:true,
    margin:20,
    nav:true,
    navText : ["<img src='https://cdn.shopify.com/s/files/1/0810/8372/8157/files/White_Left.svg?v=1722676743'>","<img src='https://cdn.shopify.com/s/files/1/0810/8372/8157/files/White_Right.svg?v=1722676743'>"],
    autoplay:false,
    dots: false,
    autoplayTimeout:5000,
    responsive:{
        0:{
            items:1.5,
            margin:15,
        },
        768:{
            items:2.5,
            margin:15,
        },
        1000:{
            items:4
        }
    }
});


$('.owl-carousel-9').owlCarousel({
    loop:true,
    margin:15,
    nav:true,
    navText : ["<img src='https://cdn.shopify.com/s/files/1/0810/8372/8157/files/White_Left.svg?v=1722676743'>","<img src='https://cdn.shopify.com/s/files/1/0810/8372/8157/files/White_Right.svg?v=1722676743'>"],
    autoplay:false,
    dots: false,
    autoplayTimeout:5000,
    responsive:{
        0:{
            items:1.5,
            margin:15,
        },
        768:{
            items:2.5,
            margin:15,
        },
        1000:{
            items:3
        }
    }
});




$('.owl-carousel-7').owlCarousel({
  loop:true,
  margin:10,
  nav:true,
  navText : ["<img src='https://cdn.shopify.com/s/files/1/0707/3225/1439/files/Left_2x.svg?v=1674560124'>","<img src='https://cdn.shopify.com/s/files/1/0707/3225/1439/files/Right_2x.svg?v=1674560137'>"],
  autoplay:false,
  dots: true,
  autoplayTimeout:5000,
  responsive:{
    0:{
        items:1
    },
    600:{
        items:1
    },
    1000:{
        items:1
    }
  }
});

  
function hideAddedProducts() {
  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    success: function (cart) {
      var cartItems = cart.items;

      // Loop through each upsell item on the page
      $(".product-container-upsell-item").each(function () {
        var $upsellItem = $(this);
        var productId = $upsellItem.data("product-id");

        // Check if this product ID is already in the cart
        var isInCart = cartItems.some(function (cartItem) {
          return cartItem.product_id == productId;
        });

        // If it's in the cart, hide this upsell item
        if (isInCart) {
          $upsellItem.hide();
        }
      });

      // Optionally: Hide the entire upsell container if no items are left visible
      $(".cart-product-container-upsell").each(function () {
        var $container = $(this);
        if ($container.find(".product-container-upsell-item:visible").length === 0) {
          $container.hide();
        }
      });
    },
    error: function (xhr, status, error) {
      console.error("Error checking cart items: ", error);
    },
  });
}

hideAddedProducts();

// $(document).on("click", ".product-container-upsell-btn a", function () {
//     var VarId = $(this).attr("data-id");
//      var data = {
//       "id": VarId,
//       "quantity":1,
//     }
//     $.ajax({
//       type: 'POST', 
//       url: '/cart/add.js',
//       dataType: 'json', 
//       data: data,
//       success: function() { 
//       $('.header__icons a#cart-icon-bubble[aria-haspopup="dialog"]').trigger("click");
//         $.ajax({
//             url: '/?section_id=cart-drawer',
//             type: 'GET',
//             dataType: 'html',
//             success:function(carthtml) {
//               $('cart-drawer').html($(carthtml).find('cart-drawer').html());

//             }
//           });
       
//        hideAddedProducts();
//       },
//       error: function(error) {alert(error.responseJSON.message);}
//     });

 
// });  
    

<!-- ============================== Disable right-click =============================================== --> 
  // Disable right-click
  document.addEventListener('contextmenu', event => event.preventDefault());

  // // Disable specific keyboard shortcuts
  // document.addEventListener('keydown', function(event) {
  //   // Block Ctrl+U, Ctrl+S, Ctrl+C, Ctrl+Shift+I, F12
  //   if (
  //     (event.ctrlKey && (event.key === 'u' || event.key === 's' || event.key === 'c')) ||
  //     (event.ctrlKey && event.shiftKey && event.key === 'I') ||
  //     (event.key === 'F12')
  //   ) {
  //     event.preventDefault();
  //     return false;
  //   }
  // });

  // Disable image dragging
  document.addEventListener("DOMContentLoaded", function() {
    const images = document.querySelectorAll("img");
    images.forEach(img => {
      img.setAttribute("draggable", "false");
    });
  });

  // Optional: disable text selection
  document.addEventListener("DOMContentLoaded", function () {
    document.body.style.userSelect = "none";
  });
  